// Lifecycle states → visual mapping (colour + icon + label).
import {
  Calendar, CheckCircle, UserCheck, Clock, Activity, CheckSquare,
  Headphones, FileText, Award, RefreshCw, XCircle, CalendarDays,
  UserMinus, Send, PlayCircle,
} from 'lucide-react';

export const LIFECYCLE_STATES = [
  'created', 'assigned', 'reminder_sent', 'confirmed',
  'en_route', 'arrived', 'consultation_started', 'consultation_completed',
  'quotation_generated', 'device_recommended', 'sale_completed',
  'followup_scheduled', 'closed', 'no_show', 'cancelled', 'rescheduled',
];

export const STATUS_META = {
  created:               { label: 'Booked',            bg: '#F3F4F6', text: '#374151', border: '#D1D5DB', icon: Calendar },
  assigned:              { label: 'Assigned',          bg: '#E0F2FE', text: '#075985', border: '#BAE6FD', icon: Send },
  reminder_sent:         { label: 'Reminder Sent',     bg: '#FEF9C3', text: '#854D0E', border: '#FEF08A', icon: Send },
  confirmed:             { label: 'Confirmed',         bg: '#EFF6FF', text: '#1D4ED8', border: '#BFDBFE', icon: CheckCircle },
  en_route:              { label: 'En Route',          bg: '#FFEDD5', text: '#9A3412', border: '#FED7AA', icon: PlayCircle },
  arrived:               { label: 'Arrived',           bg: '#F5F3FF', text: '#6D28D9', border: '#DDD6FE', icon: UserCheck },
  consultation_started:  { label: 'In Consultation',   bg: '#F0FDF4', text: '#15803D', border: '#BBF7D0', icon: Activity },
  consultation_completed:{ label: 'Consult Complete',  bg: '#ECFDF5', text: '#047857', border: '#A7F3D0', icon: CheckSquare },
  quotation_generated:   { label: 'Quotation Shared',  bg: '#FEF3C7', text: '#B45309', border: '#FDE68A', icon: FileText },
  device_recommended:    { label: 'Device Recommend',  bg: '#EEF2FF', text: '#4338CA', border: '#C7D2FE', icon: Headphones },
  sale_completed:        { label: 'Sold',              bg: '#FEF08A', text: '#854D0E', border: '#FDE047', icon: Award },
  followup_scheduled:    { label: 'Follow-up Set',     bg: '#FDF2F8', text: '#BE185D', border: '#FBCFE8', icon: RefreshCw },
  closed:                { label: 'Closed',            bg: '#F5F5F4', text: '#57534E', border: '#D6D3D1', icon: CheckSquare },
  no_show:               { label: 'No-Show',           bg: '#FAFAF9', text: '#78716C', border: '#D6D3D1', icon: UserMinus },
  cancelled:             { label: 'Cancelled',         bg: '#FEF2F2', text: '#B91C1C', border: '#FECACA', icon: XCircle },
  rescheduled:           { label: 'Rescheduled',       bg: '#E0E7FF', text: '#3730A3', border: '#C7D2FE', icon: CalendarDays },
};

export const meta = (state) => STATUS_META[state] || STATUS_META.created;

export const STATE_LABELS = Object.fromEntries(
  Object.entries(STATUS_META).map(([k, v]) => [k, v.label])
);
